import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import AvailableRoles from "../../components/Services/DeliveryTeam/AvailableRoles"
import Hero from "../../components/Services/DeliveryTeam/Hero"

const DeliveryTeam = () => {
  return (
    <Layout>
      <SEO title="Delivery Team" />
      <Hero />
      <AvailableRoles />
    </Layout>
  )
}

export default DeliveryTeam
